import React, { Component } from "react";
import Btn from "../Btn.jsx";
import Social from "../Pages/Social.jsx";
import header from "./header.module.css";

class Header extends Component {
  render() {
    return (
      <div>
        <div id="header" style={{ background: "#111a28" }}>
          <div className="space"></div>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <p className={header.p}>হ্যালো, আমি</p>
                <h2 className={header.name}>ফয়সাল আহাম্মেদ চৌধুরী</h2>
                <p className={header.p}>ফ্রন্ট-এন্ড ওয়েব ডেভেলপার</p>
                <div className="mt-3">
                  <Social firstChild="fa fa-facebook" />
                </div>
                <div className="mt-5">
                  <Btn href="javascript:void(0)" btn="সিভি দেখুন" />
                </div>
              </div>
            </div>
          </div>
          <div className="space"></div>
        </div>
      </div>
    );
  }
}
export default Header;
